import type { I18nComposer } from '@/interfaces/i18n.interface';

export function useLocale(): string | undefined {
  return (useNuxtApp().$i18n as I18nComposer | undefined)?.locale?.value;
}
